import type ApplicationInstance from '@ember/application/instance';
import type ShellBridgeService from 'garaje/services/shell-bridge';

export function initialize(appInstance: ApplicationInstance): void {
  const service = appInstance.lookup('service:shell-bridge') as ShellBridgeService;
  service.install();
}

export default {
  name: 'shell-bridge',
  initialize,
};
